import React, { useEffect, useState } from "react";
import "./AboutPage.css";
import Navbar from "./Navbar";
import BreadCrumb from "./BreadCrumb";
import Footer from "./Footer";
import { FaBolt, FaShieldAlt, FaAward, FaSyncAlt, FaWallet, FaGlobe, FaUserTie, FaChartLine } from "react-icons/fa";
import Download from "./Download";
import MediaCenter from "./MediaCenter";
import Newsletter from "./Newsletter";
import Award from "./Award";


const Trading = () => {
  const [activeSection, setActiveSection] = useState("forex");
  useEffect(() => {
    const storedSection = sessionStorage.getItem("activeSection");
    if (storedSection) {
      setActiveSection(storedSection);
      sessionStorage.removeItem("activeSection"); // Clear after applying
    }
  }, []);

  return (
    <>
      <Navbar />
      <BreadCrumb />
      <div className="about-container">
        <section className="about-section risefx-benefits-section trading">
          <div className="risefx-container">
            <h1 className="risefx-title">What Is Trading?</h1>
            <p className="risefx-description">
              Trading is the process of buying and selling financial assets such as <strong> stocks, forex, commodities, and cryptocurrencies </strong> to earn a profit. It relies on market fluctuations, where traders take advantage of price movements to generate returns. Unlike long-term investing, which focuses on gradual wealth accumulation, trading often involves shorter timeframes, ranging from minutes to months. Various factors, including economic trends, geopolitical events, and market sentiment, influence price movements, making trading a dynamic and fast-paced activity. At RiseFX, we provide a seamless trading experience, enabling traders to access global markets with speed and efficiency.
            </p>

            <p className="risefx-description">
              There are multiple types of trading strategies, such as <strong> day trading </strong>, where positions are opened and closed within a single day,<strong> swing trading </strong>, which involves holding trades for several days or weeks, and <strong> scalping </strong>, where traders aim for small but frequent profits through rapid trades. Successful traders rely on a combination of technical analysis, fundamental analysis, and risk management to make informed decisions. RiseFX offers cutting-edge tools, real-time data, and expert insights to help traders analyze markets effectively and execute trades with confidence.
            </p>
            <p className="risefx-description">
              With advancements in technology, online trading has become more accessible than ever. RiseFX provides a secure and user-friendly platform designed for both beginners and experienced traders. Our platform supports automated trading, algorithmic strategies, and charting tools, ensuring precision and efficiency. While trading offers great profit potential, it also comes with risks, making education and strategy essential. Whether you are new to trading or an expert, RiseFX equips you with the resources and support needed to succeed in the global financial markets.
            </p>
          </div>
        </section>
        {/* Navigation Buttons */}

        {/* Section Content */}
        <div className="about-content">
          <div className="about-nav">
            <button
              className={activeSection === "forex" ? "active" : ""}
              onClick={() => setActiveSection("forex")}
            >
              Forex Trade
            </button>
            <button
              className={activeSection === "metal" ? "active" : ""}
              onClick={() => setActiveSection("metal")}
            >
              Metal Trade
            </button>
            <button
              className={activeSection === "indices" ? "active" : ""}
              onClick={() => setActiveSection("indices")}
            >
              Indices Trade
            </button>
            <button
              className={activeSection === "commodities" ? "active" : ""}
              onClick={() => setActiveSection("commodities")}
            >
              Commodities Trade
            </button>
            <button
              className={activeSection === "crypto" ? "active" : ""}
              onClick={() => setActiveSection("crypto")}
            >
              Crypto Trade
            </button>
          </div>
          {activeSection === "forex" && (
            <section className="about-section risefx-benefits-section">
              <div className="risefx-container">
                <h1 className="risefx-title">Forex & Indices Trade</h1>
                <h2 className="risefx-subtitle">Your success comes first—trade securely and confidently</h2>

                <p className="risefx-description">
                Forex trading is rapidly expanding, giving traders the opportunity to invest in major global currencies. With the right platform, you can trade USD, EUR, GBP, JPY, and more from anywhere. RiseFX is the ideal trading app for beginners, offering a secure, fast, and user-friendly experience with ultra-low spreads.
                </p>
                <h2 className="risefx-subtitle">What is Forex Trading?</h2>

                <p className="risefx-description">
                Forex trading, also known as foreign exchange trading, is the process of buying one currency while simultaneously selling another to profit from fluctuations in exchange rates. It is the largest and most liquid financial market in the world, with a daily trading volume exceeding trillions of dollars. Unlike stock markets that operate within fixed hours, forex trading runs 24 hours a day, five days a week, allowing traders to take advantage of global economic events and market movements at any time.
                </p>

                <p className="risefx-description">
                The forex market consists of major, minor, and exotic currency pairs, with popular pairs like EUR/USD, GBP/USD, and USD/JPY attracting the highest trading volumes. Traders use various strategies, including<strong> technical analysis, fundamental analysis, and automated trading systems </strong>, to predict price movements and make informed trading decisions. With leverage options, even small investments can control larger positions, increasing potential profits while also carrying risk. Whether you're a beginner or an experienced trader, forex offers diverse opportunities to capitalize on the dynamic nature of currency markets.
                </p>

                <p className="risefx-description">
                  <strong>Start trading with RiseFX today and uncover endless market opportunities!</strong>
                </p>

                {/* Features Grid */}
                <div className="risefx-features-grid">
                  <div className="risefx-feature-card">
                    <FaBolt className="risefx-icon" />
                    <h3>Low Commissions</h3>
                    <p>Enjoy the lowest trading commissions in the market. Lower costs mean more profit.</p>
                  </div>

                  <div className="risefx-feature-card">
                    <FaShieldAlt className="risefx-icon" />
                    <h3>Go Long and Short</h3>
                    <p>Rise FX Markets allows you to go long or short with authority on any of our trading products.</p>
                  </div>

                  <div className="risefx-feature-card">
                    <FaChartLine className="risefx-icon" />
                    <h3>No Minimum Account Size</h3>
                    <p>Start trading with any amount that suits your budget. Perfect for beginners and experienced traders alike.</p>
                  </div>



                  <div className="risefx-feature-card">
                    <FaGlobe className="risefx-icon" />
                    <h3>No Deposit Fees</h3>
                    <p>No need to deposit funds with extra charges. Start trading with your full balance and no deductions.</p>
                  </div>
                </div>
              </div>
            </section>



          )}
          {activeSection === "metal" && (
            <section className="about-section metal">
              <div className="container">
                <h1 className="section-title">Metal Trade - Invest in Precious Metals</h1>
                <h2 className="section-subtitle">
                  Choose the Best Stock Broker Online
                </h2>
                <p className="section-description">
                Metal trade is a great way to earn by investing in<strong> gold and silver </strong>. Whether you are a beginner or an experienced trader, using the best trading app for metal allows you to trade with maximum profits. As metal is globally demanded, its price remains valuable worldwide. Metals like gold and silver are the best assets in uncertain markets.
                </p>
                <p className="section-description">
                As we are the best trading platform with real-time price tracking and tools, RiseFX is the top trading website for global investments.<strong> Create your account with the best stock broker, which gives you smooth transactions and expert support </strong>.
                </p>

                <div className="services-grid">
                  <div className="service-card">
                    <h3>Gold (XAU/USD)</h3>
                    <p>Gold is a well-known metal in the forex market and a very safe investment during an unstable economy. Traders trade gold against the US dollar to earn money from price movements using CFDs. Its value is affected by inflation, bank interest rates, and global events.</p>
                  </div>
                  <div className="service-card">
                    <h3>Silver (XAG/USD)</h3>
                    <p>Silver is a popular metal for trading in the forex market used by both investors and industry. Like gold, it is seen as a safe asset during an unstable economy. Traders can trade silver against the US dollar using CFDs to earn money from price movements.</p>
                  </div>

                </div>

                <h2 className="section-subtitle">Why Trade on Rise FX Markets?</h2>
                <div className="services-grid">
                  <div className="service-card">
                    <h3>#1 for Execution Speed in</h3>
                    <p>Our executions are the quickest, ranking #1 in for execution speed. Trade with lightning-fast order execution for the best market prices. No delays, no requotes—just smooth and efficient trading.</p>
                  </div>
                  <div className="service-card">
                    <h3>No Deposit Fees</h3>
                    <p>No need to deposit funds with any extra charges. We accept many ways of payment with zero deposit fees. Start trading with your full balance and no deductions.</p>
                  </div>
                  <div className="service-card">
                    <h3>No Long Sign-Up Process</h3>
                    <p>Get started quickly with our simple and fast registration. There is no sophisticated paperwork—just a few easy steps. Start trading in minutes with an easy and simple account setup.</p>
                  </div>
                </div>
                <a href="https://panel.therisefx.com/register">
                <button className="cta-button">Start Trading Now</button>
                </a>
              </div>
            </section>
          )}
          {activeSection === "indices" && (
            <section className="about-section risefx-benefits-section">
              <div className="risefx-container">
                <h1 className="risefx-title">Indices Trade</h1>
                <h2 className="risefx-subtitle">
                Trade with confidence because your success is our priority!
                </h2>
                <p className="risefx-description">
                Investing in indices is a great way to participate in both global and local stock markets. Whether you're trading major indices, having a reliable platform ensures a smooth and profitable experience.
                </p>
                <p className="risefx-description">
                At RiseFX, we provide a trusted, low-cost trading environment for <strong> Forex and Indices trading </strong>. With transparent pricing and the lowest brokerage fees, we empower traders to succeed in the financial markets.
                </p>

                {/* Features Grid */}
                <div className="risefx-features-grid">
                  <div className="risefx-feature-card">
                    <FaBolt className="risefx-icon" />
                    <h3>Zero Commissions</h3>
                    <p>Enjoy zero trading commissions in the market. Trade without worrying about extra fees or hidden charges.</p>
                  </div>

                  <div className="risefx-feature-card">
                    <FaShieldAlt className="risefx-icon" />
                    <h3>Go Long and Short</h3>
                    <p>Rise FX Markets allows you to go long or short with authority on any of our trading products.</p>
                  </div>

                  <div className="risefx-feature-card">
                    <FaChartLine className="risefx-icon" />
                    <h3>No Minimum Account Size</h3>
                    <p>Start trading with any amount that suits your budget. Perfect for beginners and experienced traders alike.</p>
                  </div>


                </div>
              </div>
            </section>

          )}
          {activeSection === "commodities" && (
            <section className="about-section risefx-benefits-section">
              <div className="risefx-container">
                <h1 className="risefx-title">Commodity Trade</h1>
                <h2 className="risefx-subtitle">
                  Invest In Commodities.
                </h2>
                <p className="risefx-description">
                  Invest <strong>Crude Oil and Natural Gas</strong> with ease. Commodity trading provides investors with the opportunity to trade essential raw materials, including energy sources, metals, and Crude Oil and Natural Gas. Whether you are a beginner or an experienced trader, having access to a reliable trading platform is crucial for success. Commodities often hold their value even during inflation, making them a strong addition to any investment portfolio. RiseFX is a leading trading platform and broker for commodities, offering seamless global access to commodity markets and helping traders diversify their portfolios efficiently.
                </p>

                <h2 className="risefx-subtitle">What is Commodities Trade?</h2>
                <p className="risefx-description">
                  Commodities trading involves buying and selling raw materials and natural resources, such as crude oil, gold, wheat, and coffee. These assets are traded in global markets and are influenced by factors like supply and demand, geopolitical events, and economic trends. Unlike stocks or forex, commodities trading focuses on tangible goods that remain essential to industries worldwide. Many traders choose commodities as a hedge against inflation or economic instability, as these assets often retain their value over time. RiseFX provides a secure and efficient platform to trade commodities, offering real-time data, advanced analytics, and a user-friendly interface to help traders make informed decisions.
                </p>
                <h2 className="risefx-subtitle">What are Commodity CFDs?</h2>
                <p className="risefx-description">
                  Commodity CFDs (Contracts for Difference) allow traders to speculate on the price movements of commodities without physically owning them. With CFDs, you can take advantage of rising and falling markets by going long or short, avoiding the complexities of storage and transportation. Using leverage of up to 500:1, traders can control larger positions with a smaller initial investment, maximizing profit potential while managing risk. RiseFX offers a robust and regulated trading environment for commodity CFDs, enabling traders to access global markets with competitive pricing, low spreads, and advanced trading tools.
                </p>

                <h2 className="risefx-subtitle">Why Rise FX?</h2>
                <div className="risefx-features-grid">
                  <div className="risefx-feature-card">
                    <FaAward className="risefx-icon" />
                    <h3>Award-Winning Broker</h3>
                    <p>RiseFX has been known as the Best Discount Broker for four years in a row. Our low commissions and best customer support make us different. Trade with confidence knowing you are with a trusted award-winning broker.</p>
                  </div>

                  <div className="risefx-feature-card">
                    <FaWallet className="risefx-icon" />
                    <h3>No Deposit Fees</h3>
                    <p>No need to deposit funds with any extra charges. We accept many payment methods with zero deposit fees. Start trading with your full balance and no deductions.</p>
                  </div>

                  <div className="risefx-feature-card">
                    <FaUserTie className="risefx-icon" />
                    <h3>White Glove Support</h3>
                    <p>As a live account holder at RiseFX, you get a personal trading expert to guide you. They help you navigate the markets and use the trading platform with comfort. Enjoy expert support tailored to your trading needs every step of the way.</p>
                  </div>
                </div>
              </div>
            </section>

          )}
          {activeSection === "crypto" && (
            <section className="about-section risefx-benefits-section">
              <div className="risefx-container">
                <h1 className="risefx-title">Crypto Trade</h1>
                <h2 className="risefx-subtitle">
                  Invest in Digital Assets with the Best Stock Broker Online
                </h2>
                <p className="risefx-description">
                  Crypto trading is a smart way to diversify your portfolio by investing in digital currencies like Bitcoin and Ethereum. Whether you’re a beginner or an experienced trader, using the best trading app for crypto allows you to trade efficiently and securely. As crypto is globally traded, its value is influenced by worldwide demand and innovation.
                </p>
                <p className="risefx-description">
                  Coins like Bitcoin and Ethereum are considered strong digital assets during uncertain economic times. With real-time market tracking and advanced tools, RiseFX is the top trading platform for global crypto investments. Create your account with the RiseFX and ensure smooth transactions and expert support.
                </p>


                {/* <h2 className="risefx-subtitle">Why Rise FX?</h2>
                <div className="risefx-features-grid">
                  <div className="risefx-feature-card">
                    <FaAward className="risefx-icon" />
                    <h3>Award-Winning Broker</h3>
                    <p>RiseFX has been known as the Best Discount Broker for four years in a row. Our low commissions and best customer support make us different. Trade with confidence knowing you are with a trusted award-winning broker.</p>
                  </div>

                  <div className="risefx-feature-card">
                    <FaWallet className="risefx-icon" />
                    <h3>No Deposit Fees</h3>
                    <p>No need to deposit funds with any extra charges. We accept many payment methods with zero deposit fees. Start trading with your full balance and no deductions.</p>
                  </div>

                  <div className="risefx-feature-card">
                    <FaUserTie className="risefx-icon" />
                    <h3>White Glove Support</h3>
                    <p>As a live account holder at RiseFX, you get a personal trading expert to guide you. They help you navigate the markets and use the trading platform with comfort. Enjoy expert support tailored to your trading needs every step of the way.</p>
                  </div>
                </div> */}
              </div>
            </section>

          )}
        </div>
      </div>
      <Award />
      <MediaCenter />
      <Download />
      <Newsletter />
      <Footer />
    </>
  );
};

export default Trading;
